import { ReactNode } from 'react'

import Link from 'next/link'

import { websitePaths } from 'domains/website/website.paths'

import Box from 'components/atomic/atoms/box'
import Button from 'components/atomic/atoms/button'
import Text from 'components/atomic/atoms/text'

export type TemplateHeroProps = {
  subTitle?: string
  framework: string
  svg: ReactNode
}

const TemplateHero = ({ subTitle, framework, svg }: TemplateHeroProps) => {
  return (
    <Box
      flex
      items="center"
      justify="between"
      css={{
        paddingTop: '$12',
        '@md': {
          paddingTop: 0,
          spaceX: 12
        }
      }}
    >
      <Box>
        <Text
          as="h1"
          size={{ '@initial': '3xl', '@md': '5xl' }}
          align={{ '@initial': 'center', '@md': 'left' }}
          weight="bold"
        >
          The data platform that powers your{' '}
          <Text color="gradient" size={{ '@initial': '3xl', '@md': '5xl' }}>
            {framework}
          </Text>{' '}
          application
        </Text>
        <Text
          as="p"
          color="text2"
          align={{ '@initial': 'center', '@md': 'left' }}
          size={{ '@initial': 'md', '@md': 'lg' }}
          css={{ mt: '$4' }}
        >
          {subTitle
            ? subTitle
            : `Build and scale your ${framework} application backed by your own
          GraphQL API.`}
        </Text>
        <Box
          flex={{ '@initial': 'column', '@md': true }}
          items={{ '@initial': 'center', '@md': undefined }}
          css={{
            pt: '$4'
          }}
        >
          <Link href={websitePaths.register}>
            <Button size="lg" css={{ width: 204 }}>
              Sign Up for free
            </Button>
          </Link>
        </Box>
      </Box>
      <Box
        relative
        css={{
          zIndex: -1,
          display: 'none',
          p: '$24',
          '@md': { display: 'block' }
        }}
      >
        {svg}
      </Box>
    </Box>
  )
}

export default TemplateHero
